import React, {Component} from 'react';
import PropTypes from 'prop-types';

class Paging extends Component {
  constructor(props) {
    super(props);

    this.onFirstPageClick = this.onFirstPageClick.bind(this);
    this.onNextPageClick = this.onNextPageClick.bind(this);
    this.onPreviousPageClick = this.onPreviousPageClick.bind(this);
    this.onLastPageClick = this.onLastPageClick.bind(this);
  }

  isBackAllowed() {
    return this.props.currentPage > 1;
  }

  isForwardAllowed() {
    return this.props.currentPage < this.props.maxPage;
  }

  onFirstPageClick() {
    if (this.props.onPageChange && this.props.currentPage > 1) {
      this.props.onPageChange(1);
    }
  }

  onPreviousPageClick() {
    if (this.props.onPageChange && this.props.currentPage > 1) {
      this.props.onPageChange(this.props.currentPage - 1);
    }
  }

  onNextPageClick() {
    if (this.props.onPageChange && this.props.currentPage < this.props.maxPage) {
      this.props.onPageChange(this.props.currentPage + 1);
    }
  }

  onLastPageClick() {
    if (this.props.onPageChange && this.props.currentPage < this.props.maxPage) {
      this.props.onPageChange(this.props.maxPage);
    }
  }

  getAvailableStyling() {
    return {
      opacity: 1,
      cursor: 'pointer',
    };
  }

  getDisabledStyling() {
    return {
      opacity: 0.5,
      cursor: 'not-allowed',
    };
  }

  getBackStyling() {
    if (this.isBackAllowed()) {
      return this.getAvailableStyling();
    } else {
      return this.getDisabledStyling();
    }
  }

  getForwardStyling() {
    if (this.isForwardAllowed()) {
      return this.getAvailableStyling();
    } else {
      return this.getDisabledStyling();
    }
  }

  render() {
    return (
      <div>
        <svg
          className="custom-icon first-page"
          style={this.getBackStyling()}
          onClick={this.onFirstPageClick}
        />
        <svg
          className="custom-icon previous-page"
          style={this.getBackStyling()}
          onClick={this.onPreviousPageClick}
        />
        <svg
          className="custom-icon next-page"
          style={this.getForwardStyling()}
          onClick={this.onNextPageClick}
        />
        <svg
          className="custom-icon last-page"
          style={this.getForwardStyling()}
          onClick={this.onLastPageClick}
        />
      </div>
    );
  }
}

Paging.propTypes = {
  tableId: PropTypes.string,
  minPage: PropTypes.number,
  currentPage: PropTypes.number,
  maxPage: PropTypes.number,
  onPageChange: PropTypes.func,
};
Paging.defaultProps = {};

export default Paging;
